import React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Dropdown from '../../../../../components/Dropdown';
import HtmlDate from '../../../../../components/HtmlDate';

const ScheduleInterview = ({
    setModal,
    modal,
    input,
    handleInput,
    handleSubmit,
}) => {

    return (
        <Modal className="modal fade browse-job modal-bx-info editor" size="lg" show={modal} onHide={() => setModal(false)}>
            <div className="my-0" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="ScheduleInterview">Schedule Interview</h5>
                        <button type="button" className="close" onClick={() => setModal(false)}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col xs="12" md="6" xl="6" lg="6" className="mt-2 form-group">
                                <HtmlDate
                                    label="Interview Date"
                                    name="interview_time"
                                    value={input?.interview_time}
                                    onChange={handleInput}
                                    required={true}
                                    type="datetime"
                                />
                            </Col>
                            <Col xs="12" md="6" xl="6" lg="6" className="mt-2 form-group">
                                <label>Interview Type</label>
                                <Dropdown
                                    url="interview-workflow/"
                                    name="interview_type"
                                    value={input?.interview_type}
                                    onChange={handleInput}
                                    maxMenuHeight={100}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="site-button btn-danger" onClick={() => setModal(false)}>Cancel</button>
                        <button type="button" className="site-button" onClick={() => handleSubmit()}>Save</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ScheduleInterview;